import api from '../api.js';

export const sendRequests = {
  getAllByMonthAndYear: (month, year) => {
    return api.get(`/sends/filter?month=${month}&year=${year}`, { cache: 'no-store' });
  },
  getById: (id) => {
    return api.get(`/sends/${id}`, { cache: 'no-store' });
  },
  create: (sendDto) => {
    return api.post(`/sends`, sendDto);
  },
  update: (sendDto, id) => {
    return api.put(`/sends/${id}`, sendDto);
  },
  delete: (id) => {
    return api.delete(`/sends/${id}`);
  },
};

export default sendRequests;
